/* ===========================================================================
   sp-free-gift.js  —  Silver Play automatic free-gift-with-purchase
   ---------------------------------------------------------------------------
   Adds the gift variant to the cart once the qualifying subtotal reaches the
   threshold, and removes it again if the cart drops below. The Shopify
   "Buy X get Y" automatic discount is what actually makes it FREE — this file
   only gets the item into and out of the cart. Both must be configured to the
   SAME threshold / product or the customer gets charged for the gift.

   OFFER: spend Rs 15,000 store-wide -> 1x Silver Ganesha Coin free, then
   another free coin for every additional Rs 15,000 (Rs 30,000 -> 2, etc).
   A celebration popup fires the moment the number of free coins increases.

   Load AFTER sp-corrections.js in layout/theme.liquid:
     <script src="{{ 'sp-free-gift.js' | asset_url }}" defer></script>
   =========================================================================== */
(function () {
  'use strict';

  var CFG = {
    giftVariantId: 45801811869805,
    thresholdPaise: 1500000,
    gramsPerCoin: 5,
    eligibleProductIds: null,
    giftBadgeText: 'Free gift'
  };

  var busy = false;
  var failures = 0;
  var timer = null;

  function onCheckout() {
    return window.location.pathname.indexOf('/checkouts') === 0;
  }

  function isGiftLine(line) {
    return line.variant_id === CFG.giftVariantId &&
           line.properties && line.properties._free_gift === 'true';
  }

  function qualifyingSubtotal(cart) {
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var line = cart.items[i];
      if (isGiftLine(line)) continue;
      if (CFG.eligibleProductIds &&
          CFG.eligibleProductIds.indexOf(line.product_id) === -1) continue;
      sum += line.original_line_price;
    }
    return sum;
  }

  function desiredQty(cart) {
    return Math.max(0, Math.floor(qualifyingSubtotal(cart) / CFG.thresholdPaise));
  }

  function findGiftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (isGiftLine(cart.items[i])) {
        return { line: cart.items[i], index: i + 1 };
      }
    }
    return null;
  }

  function addGift(qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: CFG.giftVariantId,
          quantity: qty,
          properties: { _free_gift: 'true' }
        }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('gift add failed');
      failures = 0;
    });
  }

  function setGiftQty(lineIndex, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: lineIndex, quantity: qty })
    });
  }

  function sync(cart) {
    if (busy || onCheckout() || !cart || !cart.items) return Promise.resolve();
    if (failures >= 3) return Promise.resolve();

    var qty = desiredQty(cart);
    var gift = findGiftLine(cart);
    var priorQty = gift ? gift.line.quantity : 0;
    var action = null;

    if (qty > 0 && !gift) {
      action = addGift(qty);
    } else if (qty === 0 && gift) {
      action = setGiftQty(gift.index, 0);
    } else if (qty > 0 && gift && gift.line.quantity !== qty) {
      action = setGiftQty(gift.index, qty);
    }

    if (!action) { decorate(cart); return Promise.resolve(); }

    busy = true;
    return action
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (fresh) {
        busy = false;
        if (qty > priorQty) {
          var freshGift = findGiftLine(fresh);
          celebrate(qty, freshGift && freshGift.line.image);
        }
        if (typeof window.spRefreshCartUI === 'function') window.spRefreshCartUI();
        else decorate(fresh);
      })
      .catch(function () { busy = false; failures++; });
  }

  function decorate(cart) {
    try {
      var nodes = document.querySelectorAll('.sp-cart-drawer__items .sp-cart-item');
      if (!nodes.length || !cart || !cart.items) return;
      for (var i = 0; i < cart.items.length && i < nodes.length; i++) {
        var remove = nodes[i].querySelector('.sp-cart-item__remove');
        if (!remove) continue;
        if (isGiftLine(cart.items[i])) {
          var badge = document.createElement('span');
          badge.className = 'sp-cart-item__remove';
          badge.style.cursor = 'default';
          badge.style.opacity = '0.7';
          badge.textContent = CFG.giftBadgeText;
          remove.parentNode.replaceChild(badge, remove);
        }
      }
    } catch (e) {}
  }

  function ensureCelebrationUI() {
    if (document.getElementById('sp-gift-pop-style')) return;
    var style = document.createElement('style');
    style.id = 'sp-gift-pop-style';
    style.textContent =
      '.sp-gift-pop{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;' +
        'justify-content:center;padding:1.5rem;opacity:0;pointer-events:none;' +
        'transition:opacity .4s;font-family:Georgia,serif;}' +
      '.sp-gift-pop.is-open{opacity:1;pointer-events:auto;}' +
      '.sp-gift-pop__scrim{position:absolute;inset:0;background:rgba(20,14,8,.86);' +
        'backdrop-filter:blur(4px);}' +
      '.sp-gift-pop__panel{position:relative;z-index:1;width:100%;max-width:24rem;' +
        'padding:3rem 2rem 2.4rem;border-radius:22px;text-align:center;' +
        'background:linear-gradient(160deg,#f9f1dc,#f2e8d0 55%,#e6d3a8);' +
        'box-shadow:0 40px 90px -20px rgba(20,15,8,.7),0 0 0 1px rgba(216,180,102,.4);' +
        'transform:scale(.4) translateY(30px);opacity:0;overflow:hidden;' +
        'transition:transform .6s cubic-bezier(.16,1.4,.3,1),opacity .4s;}' +
      '.sp-gift-pop.is-open .sp-gift-pop__panel{transform:scale(1) translateY(0);opacity:1;}' +
      '.sp-gift-pop__eyebrow{margin:0;font-family:Georgia,serif;font-size:.68rem;' +
        'letter-spacing:.28em;text-transform:uppercase;color:#8a6a2e;font-weight:700;}' +
      '.sp-gift-pop__ring{position:relative;display:inline-flex;align-items:center;' +
        'justify-content:center;height:6.5rem;width:6.5rem;margin:.9rem 0 1.1rem;' +
        'border-radius:999px;background:radial-gradient(circle,rgba(216,180,102,.35),transparent 70%);}' +
      '.sp-gift-pop.is-open .sp-gift-pop__ring{animation:spGiftRing 1.6s ease-out infinite;}' +
      '@keyframes spGiftRing{0%{box-shadow:0 0 0 0 rgba(216,180,102,.55);}' +
        '100%{box-shadow:0 0 0 18px rgba(216,180,102,0);}}' +
      '.sp-gift-pop__medal{height:5.4rem;width:5.4rem;border-radius:999px;overflow:hidden;' +
        'display:flex;align-items:center;justify-content:center;font-size:1.8rem;color:#241a10;' +
        'background:linear-gradient(155deg,#d8b466,#8a6a2e 45%,#d8b466);' +
        'box-shadow:0 14px 30px -10px rgba(138,106,46,.65),inset 0 0 0 2px rgba(255,255,255,.35);}' +
      '.sp-gift-pop__medal img{height:100%;width:100%;object-fit:cover;border-radius:999px;}' +
      '.sp-gift-pop__amount{margin:0;font-family:Georgia,serif;font-size:1.9rem;font-weight:700;' +
        'letter-spacing:.02em;color:#241a10;}' +
      '.sp-gift-pop__title{margin:.15rem 0 0;font-size:1.3rem;font-weight:700;color:#241a10;}' +
      '.sp-gift-pop__body{margin:.6rem 0 0;font-size:.98rem;line-height:1.55;' +
        'color:rgba(36,26,16,.8);}' +
      '.sp-gift-pop__close{margin-top:1.5rem;padding:.75rem 1.8rem;border:0;' +
        'border-radius:999px;cursor:pointer;font-size:.78rem;letter-spacing:.1em;' +
        'text-transform:uppercase;color:#f2e8d0;background:#241a10;}' +
      '.sp-gift-pop__stars{position:absolute;inset:0;overflow:hidden;pointer-events:none;}' +
      '.sp-gift-pop__star{position:absolute;top:50%;left:50%;border-radius:999px;opacity:0;}' +
      '.sp-gift-pop.is-open .sp-gift-pop__star{' +
        'animation:spGiftStar .95s cubic-bezier(.16,1,.3,1) forwards;}' +
      '@keyframes spGiftStar{' +
        '0%{opacity:0;transform:translate(-50%,-50%) rotate(var(--a)) translateX(0) scale(.3);}' +
        '30%{opacity:1;}' +
        '100%{opacity:0;transform:translate(-50%,-50%) rotate(var(--a)) translateX(var(--d)) scale(1);}' +
      '}';
    document.head.appendChild(style);

    var wrap = document.createElement('div');
    wrap.className = 'sp-gift-pop';
    wrap.setAttribute('aria-hidden', 'true');

    var colors = ['#d8b466', '#f2e8d0', '#b8923f'];
    var starsHtml = '';
    for (var i = 0; i < 22; i++) {
      var angle = Math.round((360 / 22) * i);
      var dist = (5 + (i % 5)) + 'rem';
      var delay = ((i % 6) * 0.035) + 's';
      var size = 4 + (i % 4) * 2;
      var color = colors[i % colors.length];
      starsHtml += '<span class="sp-gift-pop__star" style="--a:' + angle + 'deg;--d:' + dist +
        ';animation-delay:' + delay + ';height:' + size + 'px;width:' + size + 'px;' +
        'background:' + color + '"></span>';
    }

    wrap.innerHTML =
      '<div class="sp-gift-pop__scrim" data-sp-gift-close></div>' +
      '<div class="sp-gift-pop__panel" role="dialog" aria-modal="true" ' +
        'aria-label="Free silver coin unlocked">' +
        '<div class="sp-gift-pop__stars" aria-hidden="true">' + starsHtml + '</div>' +
        '<p class="sp-gift-pop__eyebrow">Free Gift Unlocked</p>' +
        '<div class="sp-gift-pop__ring"><span class="sp-gift-pop__medal" data-sp-gift-medal>&#9679;</span></div>' +
        '<p class="sp-gift-pop__amount" data-sp-gift-amount></p>' +
        '<p class="sp-gift-pop__title">Congratulations!</p>' +
        '<p class="sp-gift-pop__body" data-sp-gift-text></p>' +
        '<button type="button" class="sp-gift-pop__close" data-sp-gift-close>Yay!</button>' +
      '</div>';
    document.body.appendChild(wrap);

    var closers = wrap.querySelectorAll('[data-sp-gift-close]');
    for (var j = 0; j < closers.length; j++) {
      closers[j].addEventListener('click', function () {
        wrap.classList.remove('is-open');
        wrap.setAttribute('aria-hidden', 'true');
      });
    }
  }

  function celebrate(qty, imageUrl) {
    try {
      ensureCelebrationUI();
      var wrap = document.querySelector('.sp-gift-pop');
      if (!wrap) return;
      var grams = qty * CFG.gramsPerCoin;

      var medal = wrap.querySelector('[data-sp-gift-medal]');
      if (medal) {
        medal.innerHTML = imageUrl
          ? '<img src="' + imageUrl + '" alt="">'
          : '&#9679;';
      }

      var amount = wrap.querySelector('[data-sp-gift-amount]');
      if (amount) amount.textContent = grams + ' GRAMS FREE';

      var text = wrap.querySelector('[data-sp-gift-text]');
      if (text) {
        text.textContent = qty > 1
          ? "You've received " + qty + ' free silver coins (5g each) — ' + grams +
            ' grams in total of 99.9% pure silver, absolutely free!'
          : "You've received a free 5 gram, 99.9% pure silver coin!";
      }

      wrap.classList.remove('is-open');
      void wrap.offsetWidth;
      wrap.classList.add('is-open');
      wrap.setAttribute('aria-hidden', 'false');
    } catch (e) {}
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(sync)
        .catch(function () {});
    }, 150);
  }

  try {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var mutates = /\/cart\/(add|change|update|clear)/.test(url);
      return origFetch.apply(this, arguments).then(function (res) {
        if (mutates && res && res.ok && !busy) schedule();
        return res;
      });
    };
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();